import { map } from 'rxjs/operators/map';
import { CategorySerializer } from '../../models';
import ajax from '../../utils/ajax';

class CategoryService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/category';
  configurationPathGroup = '/networkAsset/airfinder/categories';

  /**
    Get categories in a site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  getBySiteId = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(CategorySerializer.normalize)));
  };

  /**
    Create a Category
    @param {Object} category
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (category, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: CategorySerializer.serialize(category),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => CategorySerializer.normalize(data.response)));
  };

  /**
    Edit a Category
    @param {Object} category
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (category, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${category.id}`,
        body: CategorySerializer.editSerialize(category),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => CategorySerializer.normalize(data.response)));
  };

  /**
    Delete a Category
    @param {Object} category
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  delete = (category, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${category.id}`,
        body: CategorySerializer.deleteSerialize(category),
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new CategoryService();



// WEBPACK FOOTER //
// ./src/services/category/index.js